import { useQuery } from "@tanstack/react-query";

import { API_URL } from "@/constants/envVariables";
import { ACTIVE_UNENROLLMENT_STATUSES } from "@/constants/multisigUnenrollment";

import { fetchApi } from "@/helpers/fetchApi";
import { mapUnenrollmentError, UnenrollmentError } from "@/helpers/unenrollmentErrors";

import type {
  AppError,
  MultisigUnenrollmentTransaction,
  MultisigUnenrollmentTxStatus,
} from "@/types";

export const MULTISIG_UNENROLLMENT_QUERY_KEY = ["multisigUnenrollment"] as const;
export const MULTISIG_UNENROLLMENT_URL = `${API_URL}/multisig/unenrollment`;

export const isActiveUnenrollmentStatus = (
  status: MultisigUnenrollmentTxStatus | undefined | null,
): boolean => !!status && ACTIVE_UNENROLLMENT_STATUSES.includes(status);

export const fetchMultisigUnenrollment =
  async (): Promise<MultisigUnenrollmentTransaction | null> => {
    try {
      const tx = (await fetchApi(MULTISIG_UNENROLLMENT_URL)) as
        | MultisigUnenrollmentTransaction
        | undefined;
      if (tx === undefined) {
        throw mapUnenrollmentError({ message: "", status: 401 });
      }
      return tx;
    } catch (err) {
      if ((err as AppError)?.status === 404) return null;
      throw mapUnenrollmentError(err);
    }
  };

export const useMultisigUnenrollment = (options?: { enabled?: boolean }) =>
  useQuery<MultisigUnenrollmentTransaction | null, UnenrollmentError>({
    queryKey: MULTISIG_UNENROLLMENT_QUERY_KEY,
    queryFn: fetchMultisigUnenrollment,
    enabled: options?.enabled ?? true,
  });
